export const GET_POPULAR_DESTINATIONS = 'GET_POPULAR_DESTINATIONS';
export const GET_POPULAR_DESTINATIONS_SUCCESS = 'GET_POPULAR_DESTINATIONS_SUCCESS';
